import { filmProfile } from '@/mocks/filmData';

export default function FilmProfile() {
  return (
    <section id="profile" className="scroll-mt-20 bg-background-50">
      <div className="px-5 md:px-10 py-14 md:py-20">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-10 h-10 rounded-md bg-secondary-100 text-secondary-900 flex items-center justify-center">
            <i className="ri-profile-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="text-xs font-medium tracking-widest text-secondary-700 uppercase">Overview</span>
        </div>
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">影片档案</h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-3xl leading-relaxed">
          先建立对作品与语言版本的整体认识。以下信息帮助你判断该以哪种方式开始浏览，再进入后续的字幕与版本说明。
        </p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filmProfile.map((item) => (
            <div
              key={item.key}
              className="rounded-lg bg-background-100 border border-background-200 p-5"
            >
              <p className="text-xs font-medium text-primary-700">{item.key}</p>
              <p className="mt-2 font-heading text-lg font-semibold text-foreground-950">{item.value}</p>
              <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{item.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}